<template>
  <v-dialog :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <div class="pa-4">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-4">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.background"
                    @change="event => (fields.styleSection.background = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.textColor"
                    @change="event => (fields.styleSection.textColor = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.textColor" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.topPadding"
                  label="Top Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.bottomPadding"
                  label="Bottom Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <label>Column per view</label>
                <v-text-field v-model.number="fields.colPerView" type="number" min="1" :hide-details="true" />
              </v-col>
              <v-col cols="12" md="6">
                <label>Space between (px)</label>
                <v-text-field v-model.number="fields.spaceBetween" type="number" min="0" :hide-details="true" />
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.containerPage.enableStyle"
                  label="Enable Style Container"
                  :hide-details="true"
                />
                <div v-if="fields.containerPage.enableStyle">
                  <v-row>
                    <v-col cols="12" md="6">
                      <label>Background Container</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields.containerPage.background"
                          @change="event => (fields.containerPage.background = event.target.value)"
                        />
                        <v-text-field v-model="fields.containerPage.background" :hide-details="true" class="mt-0" />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="label-input">Card Title</div>
          <div class="group-item">
            <v-checkbox v-model="fields.showCardTitle" label="Show card title" :hide-details="true" class="mb-2 mt-0" />
            <ckeditor :editor="editor" v-model="fields.cardTitle" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Product Items</label>
            <v-btn small color="primary" @click="handleAddProduct">Add Product</v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(product, productIndex) in fields.listItem" :key="`product-${productIndex}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>{{ `Product ${productIndex + 1}` }}</span>
                  <v-btn small icon @click.stop="handleRemoveProduct(productIndex)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-3">
                  <label>Product Name</label>
                  <ckeditor :editor="editor" v-model="product.productName" :config="editorConfig" />
                </div>
                <div class="mb-3">
                  <label>Link Product</label>
                  <v-text-field v-model="product.linkProduct" :hide-details="true" />
                </div>
                <div class="mb-3">
                  <div>
                    <label>Rating</label>
                    <v-rating
                      color="warning"
                      background-color="#c1c1c1"
                      empty-icon="mdi-star-outline"
                      full-icon="mdi-star"
                      half-icon="mdi-star-half-full"
                      hover
                      length="5"
                      size="35"
                      :value="product.rating.value"
                      @input="value => (product.rating.value = value)"
                    ></v-rating>
                  </div>
                  <div>
                    <label>Review Count</label>
                    <v-text-field v-model="product.rating.reviewCount" :hide-details="true" />
                  </div>
                </div>

                <div class="group-item mb-3">
                  <div class="label-input" style="font-size: 15px !important">Price</div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <label>From Text</label>
                      <v-text-field v-model="product.productPrice.fromText" :hide-details="true" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <label>State Product</label>
                      <v-text-field v-model="product.productPrice.stateProduct" :hide-details="true" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <label>Price New</label>
                      <v-text-field v-model="product.productPrice.priceNew" :hide-details="true" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <label>Price Old</label>
                      <v-text-field v-model="product.productPrice.priceOld" :hide-details="true" />
                    </v-col>
                  </v-row>
                </div>

                <div class="group-item">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <div class="label-input mb-0" style="font-size: 15px !important">Color Variants</div>
                    <v-btn small color="primary" @click="handleAddVariant(productIndex)">Add Color</v-btn>
                  </div>

                  <v-expansion-panels accordion multiple>
                    <v-expansion-panel
                      v-for="(variant, variantKey, variantIndex) in product.colorVariants"
                      :key="`variant-${productIndex}-${variantKey}-${variantIndex}`"
                    >
                      <v-expansion-panel-header>
                        <div class="d-flex justify-space-between align-center" style="width: 100%">
                          <div class="d-flex align-center">
                            <div class="mr-2" v-if="variant.useThumbnail">
                              <div class="thumbnail-variant">
                                <img :src="variant.thumbnail" alt="Thumbnail" />
                              </div>
                            </div>
                            <span
                              :style="{
                                display: 'inline-block',
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                marginRight: '8px',
                                border: '1px solid #ddd',
                                background: variant.color || '#000000',
                              }"
                            ></span>
                            <span>{{ variant.label || variantKey }}</span>
                            <span v-if="variant.active" class="ml-2" style="color: #0081c7; font-size: 12px"
                              >(active)</span
                            >
                            <span v-if="variant.soldOut" class="ml-2" style="color: #ff6c6c; font-size: 12px"
                              >(sold out)</span
                            >
                          </div>
                          <v-btn small icon @click.stop="handleRemoveVariant(productIndex, variantKey)">
                            <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" md="4">
                            <label>Key</label>
                            <v-text-field
                              :value="variantKey"
                              @change="newKey => handleRenameVariantKey(productIndex, variantKey, newKey)"
                              :hide-details="true"
                            />
                          </v-col>
                          <v-col cols="12" md="4">
                            <label>Label</label>
                            <v-text-field v-model="variant.label" :hide-details="true" />
                          </v-col>
                          <v-col cols="12" md="4">
                            <label>Color</label>
                            <div class="d-flex align-center gap-3">
                              <input
                                type="color"
                                style="width: 40px; height: 40px; margin-right: 12px"
                                :value="variant.color"
                                @change="event => (variant.color = event.target.value)"
                              />
                              <v-text-field v-model="variant.color" :hide-details="true" class="mt-0" />
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox
                              class="mt-0 mb-0"
                              v-model="variant.active"
                              label="Active by default"
                              :hide-details="true"
                              @change="checked => checked && handleSetActiveVariant(productIndex, variantKey)"
                            />
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox
                              class="mt-0 mb-0"
                              v-model="variant.soldOut"
                              label="Sold out"
                              :hide-details="true"
                            />
                          </v-col>
                        </v-row>

                        <div>
                          <div>
                            <v-checkbox
                              class="mt-0 mb-0"
                              v-model="variant.useThumbnail"
                              label="Use Thumbnail"
                              :hide-details="true"
                            />
                          </div>
                          <div v-if="variant.useThumbnail">
                            <UploadImage
                              :image="{ imageSrc: variant.thumbnail }"
                              :height="`180`"
                              :typeUpload="'image'"
                              @callback="obj => handleUploadThumbnail(obj, productIndex, variantKey)"
                              @callbackDelete="() => handleRemoveThumbnail(productIndex, variantKey)"
                            />
                          </div>
                        </div>

                        <v-divider class="my-5"></v-divider>

                        <div class="d-flex justify-space-between align-center mt-3 mb-2">
                          <label class="label-input mb-0" style="font-size: 14px !important">Images</label>
                          <v-btn x-small color="primary" @click="handleAddImage(productIndex, variantKey)">
                            Add Image
                          </v-btn>
                        </div>
                        <div
                          v-for="(imgItem, imgIndex) in variant.images"
                          :key="`img-${productIndex}-${variantKey}-${imgIndex}`"
                          class="mb-3"
                        >
                          <div class="d-flex justify-space-between align-center mb-1">
                            <span style="font-size: 13px; color: #777">Image {{ imgIndex + 1 }}</span>
                            <v-btn
                              x-small
                              icon
                              :disabled="variant.images.length <= 1"
                              @click="handleRemoveImage(productIndex, variantKey, imgIndex)"
                            >
                              <v-icon size="16" color="#ff6c6c">mdi-delete</v-icon>
                            </v-btn>
                          </div>
                          <UploadImage
                            :image="{ imageSrc: imgItem.image }"
                            :height="`180`"
                            :typeUpload="'image'"
                            @callback="obj => handleUploadImage(obj, productIndex, variantKey, imgIndex)"
                            @callbackDelete="() => handleRemoveUploadImage(productIndex, variantKey, imgIndex)"
                          />
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

const defaultImage = () => ({ image: '' });

const defaultVariant = (overrides = {}) => ({
  color: '#000000',
  label: 'New',
  soldOut: false,
  active: false,
  useThumbnail: false,
  thumbnail: '',
  images: [defaultImage()],
  ...overrides,
});

const defaultProduct = () => ({
  productName: `
  <h3>Product Name</h3>
  <p>Product description</p>
  `,
  linkProduct: '#',
  rating: {
    value: 5,
    reviewCount: '5 reviews',
  },
  productPrice: {
    fromText: 'From',
    priceNew: '$0.00',
    priceOld: '$0.00',
    stateProduct: '',
  },
  colorVariants: {
    default: defaultVariant({ label: 'Default', active: true }),
  },
});

const defaultFields = () => ({
  title: 'Product With Variant Section',
  cardTitle: '',
  showCardTitle: true,
  styleSection: {
    topPadding: true,
    bottomPadding: true,
    background: '#FFFFFF',
    textColor: '#000000',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  colPerView: 4,
  spaceBetween: 25,
  listItem: [defaultProduct()],
});

const sanitizeKey = (raw, fallback) => {
  const text = String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-_]/g, '');
  return text || fallback;
};

export default {
  name: 'ProductWithVariantSectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: defaultFields(),
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
    };
  },
  mounted() {
    const fallback = defaultFields();
    const extracted = this.sectionEditor.sectionExtract || {};
    const list =
      Array.isArray(extracted.listItem) && extracted.listItem.length ? extracted.listItem : fallback.listItem;
    this.fields = {
      ...fallback,
      ...extracted,
      styleSection: { ...fallback.styleSection, ...(extracted.styleSection || {}) },
      containerPage: { ...fallback.containerPage, ...(extracted.containerPage || {}) },
      listItem: list.map(item => ({
        productName: item.productName || '',
        linkProduct: item.linkProduct || '#',
        rating: {
          value: item.rating?.value || 5,
          reviewCount: item.rating?.reviewCount || '5 reviews',
        },
        productPrice: {
          fromText: item.productPrice?.fromText || 'From',
          priceNew: item.productPrice?.priceNew || '',
          priceOld: item.productPrice?.priceOld || '',
          stateProduct: item.productPrice?.stateProduct || '',
        },
        colorVariants: Object.fromEntries(
          Object.entries(item.colorVariants || {}).map(([key, variant]) => [
            key,
            {
              color: variant?.color || '#000000',
              label: variant?.label || key,
              soldOut: !!variant?.soldOut,
              active: !!variant?.active,
              useThumbnail: !!variant?.useThumbnail,
              thumbnail: variant?.thumbnail || '',
              images:
                Array.isArray(variant?.images) && variant.images.length
                  ? variant.images.map(img => ({ image: img?.image || '' }))
                  : [defaultImage()],
            },
          ]),
        ),
      })),
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        colPerView: Number(this.fields.colPerView) > 0 ? Number(this.fields.colPerView) : 1,
        spaceBetween: Number(this.fields.spaceBetween) >= 0 ? Number(this.fields.spaceBetween) : 0,
        listItem: (this.fields.listItem || []).map(item => ({
          productName: item.productName || '',
          linkProduct: item.linkProduct || '#',
          rating: { ...item.rating },
          productPrice: { ...item.productPrice },
          colorVariants: item.colorVariants || {},
        })),
      };
      if (!payload.listItem.length) payload.listItem = [defaultProduct()];

      const updateHtml = updateHtmlFromData.sectionProductWithVariant(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: payload.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddProduct() {
      this.fields.listItem.push(defaultProduct());
    },
    handleRemoveProduct(index) {
      if (this.fields.listItem.length <= 1) return;
      this.fields.listItem.splice(index, 1);
    },
    handleAddVariant(productIndex) {
      const product = this.fields.listItem[productIndex];
      if (!product) return;
      const existingKeys = Object.keys(product.colorVariants || {});
      let suffix = existingKeys.length + 1;
      let key = `color-${suffix}`;
      while (existingKeys.includes(key)) {
        suffix += 1;
        key = `color-${suffix}`;
      }
      this.$set(product.colorVariants, key, defaultVariant({ label: key }));
    },
    handleRemoveVariant(productIndex, variantKey) {
      const product = this.fields.listItem[productIndex];
      if (!product) return;
      this.$delete(product.colorVariants, variantKey);
    },
    handleRenameVariantKey(productIndex, oldKey, rawNewKey) {
      const product = this.fields.listItem[productIndex];
      if (!product) return;
      const newKey = sanitizeKey(rawNewKey, oldKey);
      if (!newKey || newKey === oldKey) return;
      if (product.colorVariants[newKey]) return;

      const ordered = {};
      Object.entries(product.colorVariants).forEach(([key, value]) => {
        ordered[key === oldKey ? newKey : key] = value;
      });
      this.$set(product, 'colorVariants', ordered);
    },
    handleSetActiveVariant(productIndex, variantKey) {
      const product = this.fields.listItem[productIndex];
      if (!product) return;
      Object.entries(product.colorVariants).forEach(([key, variant]) => {
        variant.active = key === variantKey;
      });
    },
    handleAddImage(productIndex, variantKey) {
      const variant = this.fields.listItem[productIndex]?.colorVariants?.[variantKey];
      if (!variant) return;
      variant.images.push(defaultImage());
    },
    handleRemoveImage(productIndex, variantKey, imgIndex) {
      const variant = this.fields.listItem[productIndex]?.colorVariants?.[variantKey];
      if (!variant) return;
      if (variant.images.length <= 1) return;
      variant.images.splice(imgIndex, 1);
    },
    handleUploadImage(obj, productIndex, variantKey, imgIndex) {
      const variant = this.fields.listItem[productIndex]?.colorVariants?.[variantKey];
      if (!variant) return;
      variant.images[imgIndex].image = obj?.imageSrc || '';
    },
    handleRemoveUploadImage(productIndex, variantKey, imgIndex) {
      const variant = this.fields.listItem[productIndex]?.colorVariants?.[variantKey];
      if (!variant) return;
      variant.images[imgIndex].image = '';
    },
    handleUploadThumbnail(obj, productIndex, variantKey) {
      const variant = this.fields.listItem[productIndex]?.colorVariants?.[variantKey];
      if (!variant) return;
      variant.thumbnail = obj?.imageSrc || '';
    },
    handleRemoveThumbnail(productIndex, variantKey) {
      const variant = this.fields.listItem[productIndex]?.colorVariants?.[variantKey];
      if (!variant) return;
      variant.thumbnail = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  border: 1px solid #0000000f;
  border-radius: 8px;
  padding: 16px 12px;
  margin-bottom: 10px;
}
.thumbnail-variant {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    inset: 0;
    position: absolute;
    object-fit: cover;
  }
}
</style>
